import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-detail-pane iodine-no-scroll-y full-height text-center flex column" }
const _hoisted_2 = { class: "reference-content-container iodine-scrollable-y" }

import {ref, Ref, watch} from 'vue';

    import ReferencesDetailTitle from 'components/references/ReferencesDetailTitle.vue';
    import ReferencesDetailToolbar from 'components/references/ReferencesDetailToolbar.vue';
    import ReferencesContent from 'components/references/ReferencesContent.vue';
    import { ReferencesHistoryService } from 'src/services/ReferencesHistoryService';
    import { ReferencesHistoryData } from 'src/services/ReferencesHistoryService';
    import { storeToRefs } from 'pinia';
    import { useTrucodeReferenceStore } from 'stores/references-store';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesDetail',
  setup(__props) {

    const { currentArticle } = storeToRefs(useTrucodeReferenceStore());

    const curReferencesHistoryData: Ref<ReferencesHistoryData | null> = ref({
      bookCode: '',
      bookDescription: '',
      articleId: '',
      articleDescription: ''
    })
    const backButtonEnabled: Ref<boolean> = ref(ReferencesHistoryService.getInstance().isPrevAvailable())
    const nextButtonEnabled: Ref<boolean> = ref(ReferencesHistoryService.getInstance().isNextAvailable())
    const browseIssueButtonEnabled: Ref<boolean> = ref(ReferencesHistoryService.getInstance().isCurrentAvailable())

    function updateButtons() {
        backButtonEnabled.value = ReferencesHistoryService.getInstance().isPrevAvailable();
        nextButtonEnabled.value = ReferencesHistoryService.getInstance().isNextAvailable();
        browseIssueButtonEnabled.value = ReferencesHistoryService.getInstance().isCurrentAvailable();
    }

    watch(currentArticle, (newData) => {
        curReferencesHistoryData.value = ReferencesHistoryService.getInstance().addToHistory(<ReferencesHistoryData>newData);
        updateButtons();
    });

    const onBackButtonClicked = () => {
        curReferencesHistoryData.value = ReferencesHistoryService.getInstance().getPrev();
        updateButtons();
    };

    const onNextButtonClicked = () => {
        curReferencesHistoryData.value = ReferencesHistoryService.getInstance().getNext();
        updateButtons();
    };

    const onPrintButtonClicked = () => {
        console.log('Print button clicked');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReferencesDetailTitle, {
      "book-description": curReferencesHistoryData.value.bookDescription
    }, null, 8, ["book-description"]),
    _createVNode(ReferencesDetailToolbar, {
      "enable-back-button": backButtonEnabled.value,
      "enable-next-button": nextButtonEnabled.value,
      "enable-browse-issue": browseIssueButtonEnabled.value,
      "title-description": curReferencesHistoryData.value.articleDescription,
      onBackButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked())),
      onNextButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked())),
      onPrintButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (onPrintButtonClicked()))
    }, null, 8, ["enable-back-button", "enable-next-button", "enable-browse-issue", "title-description"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReferencesContent, {
        "article-id": curReferencesHistoryData.value?.articleId
      }, null, 8, ["article-id"])
    ])
  ]))
}
}

})